import rpcShared from '@rockpapercoin/rpc-shared';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout as reduxLogout } from '../redux/actions';
import { Routes } from './routes';
import { FlattenedUser } from '../types/user';
import { UserType, useUseProfileLinks_LogoutMutation } from '#types';
import { gql } from '@apollo/client';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useProfileLinks_logout = gql`
	mutation useProfileLinks_logout {
		logout
	}
`;

export enum ProfileLinkIds {
	Profile = 'profile',
	Admin = 'admin',
	Wallet = 'wallet',
	SignOut = 'signout',
}

export default function useProfileLinks() {
	const dispatch = useDispatch();
	const user: FlattenedUser = useSelector( ( state: any ) => state.user );

	const [ logout ] = useUseProfileLinks_LogoutMutation();

	const orgUser =
		user?.isLoggedIn && user.userType === UserType.OrgUser ? user : undefined;
	const isAdminOrManager = orgUser
		? rpcShared.organizations.isAdminOrManager( orgUser.organization, orgUser )
		: false;

	const items: ( { id: string; label: string } & (
		| { href: string; onClick?: () => void }
		| { onClick: () => Promise<void> }
	) )[] = useMemo(
		() => [
			{
				id: ProfileLinkIds.Profile,
				label: 'Profile',
				href: Routes.Profile,
			},
			{
				id: ProfileLinkIds.Admin,
				label: 'Admin',
				href: Routes.Admin,
				isVisible: isAdminOrManager,
			},
			{
				id: ProfileLinkIds.Wallet,
				label: 'My Wallet',
				href: Routes.Wallet,
			},
			{
				id: ProfileLinkIds.SignOut,
				label: 'Sign Out',
				onClick: async () => {
					await logout();
					dispatch( reduxLogout() );
				},
			},
		],
		[
			isAdminOrManager,
			logout,
			dispatch
		]
	);

	return items;
}
